import { render, staticRenderFns } from "./StickerRemoveStickerButton.vue?vue&type=template&id=68cd9744&scoped=true"
import script from "./StickerRemoveStickerButton.vue?vue&type=script&lang=ts"
export * from "./StickerRemoveStickerButton.vue?vue&type=script&lang=ts"
import style0 from "./StickerRemoveStickerButton.vue?vue&type=style&index=0&id=68cd9744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd9744",
  null
  
)

export default component.exports